const groupCategoryList = [
  // { id: 1, name: "模擬店(食品販売)" },
  { id: 2, name: "模擬店(物品販売)" },
  { id: 3, name: "ステージ企画" },
  { id: 4, name: "展示・体験" },
  // { id: 5, name: "研究室公開" },
  { id: 6, name: "その他" },
]

export default groupCategoryList
